import React, {useContext} from "react";
import styled from "styled-components";
import color from "../../assets/colors";
import ItemMenu from "./ItemMenu";
import {ReactComponent as LogoutIcon} from "../../assets/icons/logout.svg";
import RoutesList from "../../constants/RouterList";
import {AuthContext} from "../../context/AuthProvider";

export default function Menu() {
   const {doLogout} = useContext(AuthContext);
   return (
      <ContMenu>
         <HeadNav>
            <img src={require("../../assets/logo/logoNav.png")} className="styleLogoNav" alt="domecq" />
         </HeadNav>
         <MenuList>
            {React.Children.toArray(
               RoutesList.map(item => {
                  if (item.nav) {
                     return <ItemMenu name={item.name} path={item.path} back={item.back} Icon={item.icon} />;
                  }
                  return null;
               }),
            )}
            <LogoutBtn onClick={doLogout}>
               <LogoutIcon fill="#001b5b" width="2em" height="2em" />
               {/* <span>cerar</span> */}
            </LogoutBtn>
         </MenuList>
      </ContMenu>
   );
}

const ContMenu = styled.div`
   width: 100%;
   // height: 100%;
   box-sizing: border-box;
   margin: 0 auto;
   padding-left: inherit;
   // border-bottom: 1px solid ${props => props.color || color.txtInput};
   display: grid;
   grid-template-columns: 1fr;
   grid-template-rows: repeat(15, 1fr);
`;

const HeadNav = styled.div`
   grid-area: 1 / 1 / span 2 / span 3;
   display: flex;
   justify-content: center;
   align-items: center;
   border-right: 1px solid #1c355e;

   & .styleLogoNav {
      width: 80%;
      margin: 0 auto;
      display: block;
   }
`;

const MenuList = styled.div`
   grid-area: 3 / 1 / span 13 / span 2;
   display: flex;
   flex-direction: column;
   border-bottom: 1px solid ${props => props.color};
`;

const LogoutBtn = styled.button`
   border: none;
   background: none;
   outline: none;
   cursor: pointer;
   // grid-area: 14 / 1 / 16 / 1;
   padding: 2em 0;
   display: flex;
   justify-content: center;
   align-items: center;
   flex-direction: column;
   border-right: 1px solid #1c355e;

   & span {
      opacity: 0;
   }
`;
